import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteWorkshop, getWorkshops } from "../../redux/services/workshopSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { useDispatch, useSelector } from "react-redux";

const Workshop = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getWorkshopData = useSelector((state) => state?.workshop?.workshopData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllWorkshops = useCallback(async () => {
    try {
      await dispatch(getWorkshops({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) { }
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllWorkshops();
  }, [getAllWorkshops]);

  const deleteWorkshopData = async () => {
    try {
      const response = await dispatch(deleteWorkshop(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllWorkshops();
    } catch (error) { }
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Title",
      key: "title",
    },
    // {
    //   header: "Description",
    //   key: "description",
    //   render: (value) => (
    //     <p className=" truncate max-w-[400px] text-foreground">{value || "—"}</p>
    //   ),
    // },
    {
      header: "Description", key: "description",
      render: (value) =>
        value ? (
          <div className="truncate max-w-[400px]" dangerouslySetInnerHTML={{ __html: value }} ></div>
        ) : (
          "—"
        ),
    },
    {
      header: "Image",
      key: "image",
      render: (value) =>
        value ? (
          <div className="w-16 h-16 rounded-xl overflow-hidden border border-border">
            <img src={value} alt="Workshop" className="w-full h-full object-cover" />
          </div>
        ) : (
          "—"
        ),
    },
    {
      header: "Language",
      key: "language",
    },
    {
      header: "Money Back",
      key: "moneyBack",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      header: "Priority",
      key: "priority",
    },
    {
      header: "Total Tests",
      key: "totalTest",
    },
    {
      header: "Syllabus Level",
      key: "syllabus",
    },
    {
      header: "Total Amount (₹)",
      key: "totalAmount",
    },
    {
      header: "Discount (₹)",
      key: "discountAmount",
    },
    {
      header: "PDF",
      key: "pdf",
      render: (pdf) =>
        pdf ? (
          <a
            href={pdf}
            target="_blank"
            rel="noreferrer"
            className="text-primary underline"
          >
            View
          </a>
        ) : (
          "—"
        ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WORKSHOPS.WORKSHOP_ADD_EDIT}?workshopId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="Workshop"
        buttonTitle="Add Workshop"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WORKSHOPS.WORKSHOP_ADD_EDIT)}
        columns={columns}
        data={getWorkshopData?.workshop_data || []}
        actions={actions}
        pageCount={getWorkshopData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Workshop"
          confirm={confirm}
          onDelete={deleteWorkshopData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default Workshop;
